import { render, staticRenderFns } from "./SelectCategoryParentGP.vue?vue&type=template&id=10bd210c&"
import script from "./SelectCategoryParentGP.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryParentGP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports